import React from 'react';
import { RadioGroup } from 'components/UI/V3/Forms/RadioGroup';
import styles from './BoardingPricingTypeSelector.module.scss';

interface BoardingPricingTypeSelectorProps {
    value: 'fixed' | 'by_pet_size';
    onChange: (value: 'fixed' | 'by_pet_size') => void;
    className?: string;
}

const pricingTypeOptions = [
    {
        value: 'fixed' as const,
        inlineLabel: 'Fixed Price'
    }
    /*{
        value: 'by_pet_size' as const,
        inlineLabel: 'By Pet Size'
    }*/
];

export const BoardingPricingTypeSelector: React.FC<BoardingPricingTypeSelectorProps> = ({
    value,
    onChange,
    className
}) => {
    return (
        <div className={className}>
            <RadioGroup
                options={pricingTypeOptions}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};
